import { CheckboxField, useControlledField } from '@frontend/design-system';
import { useCompactTableRowContext } from '../../../context/compact-table-row-context';

export const CompactTableSelectRow = () => {
  const { handleRowSelect, isSelected, isSelectionDisabled, tableId, id, isSelectable, item } =
    useCompactTableRowContext();
  const checkboxProps = useControlledField({
    type: 'checkbox',
    value: isSelected,
    onChange: () => handleRowSelect(item, isSelected),
  });

  if (!isSelectable) return null;

  return <CheckboxField name={`${tableId}-${id}`} label={''} {...checkboxProps} disabled={isSelectionDisabled} />;
};
